// extracted by mini-css-extract-plugin
export default {"container":"Userlogs_container__zz2Z8","modalBtn":"Userlogs_modalBtn__AfJf1"};